import { render, staticRenderFns } from "./DisplayImageUpload.vue?vue&type=template&id=ca65237e&"
import script from "./DisplayImageUpload.vue?vue&type=script&lang=js&"
export * from "./DisplayImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports